module.exports = __webpack_public_path__ + "media/images/arrow-right-eda6d9d3d51851fc9acccc900fdec479847434636ddf3217d8eb95fb96b3cb5f.svg";